import { createFileRoute } from '@tanstack/react-router'

import { MerchantsPage } from '@/modules/insights/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/insights/merchants',
)({
  component: () => <MerchantsPage slug={Route.useParams().slug} />,
})
